import BaseEntity from "../base/BaseEntity";
import Filter from "../base/Filter";
import TopicMenu from "./TopicMenu";
import Article from "../article/Article";
import Scenery from "../lover/Scenery";
import Tank from "../tank/Tank";
import {sceneryMap} from "../../store/Sceneries";
import {themeMap} from "../../store/Themes";
import Theme from "../lover/Theme";
import {startWith} from "../../filter/str";
import Vue from "vue";

let Status = {
	OK: "OK",
	DISABLED: "DISABLED"
};

let StatusMap = {
	OK: {
		name: "生效",
		value: "OK",
		style: "success"
	},
	DISABLED: {
		name: "未生效",
		value: "DISABLED",
		style: "danger"
	}
};

let Type = {
	ARTICLE: "ARTICLE",
	SCENERY: "SCENERY"
};

let TypeMap = {
	ARTICLE: {
		name: "文章",
		value: "ARTICLE",
		style: "success"
	},
	SCENERY: {
		name: "定制页面",
		value: "SCENERY",
		style: "primary"
	}
};


export default function Topic() {

	//extend BaseEntity's Attributes.
	BaseEntity.call(this, arguments);

	this.name = null;
	this.description = null;
	//Tank Object
	this.poster = new Tank("image", false);
	//首页
	this.type = Type.ARTICLE;
	this.article = new Article();
	this.scenery = new Scenery();
	this.theme = new Theme();
	this.location = null;


	this.menus = [];
	this.remark = null;

	this.status = null;

	//当前状态下的那个menu. level=0的那个。
	this.activeModuleMenu = null;
	//level=1的那个目录。
	this.activeChildMenu = null;
}


//extend BaseEntity
Topic.prototype = new BaseEntity();
Topic.prototype.constructor = Topic;
Topic.prototype.TAG = "topic";
Topic.prototype.TAGS = "topics";
Topic.prototype.URL_PAGE = "/topic/page";
Topic.prototype.URL_DETAIL = "/topic/detail/{id}";
Topic.prototype.URL_CREATE = "/topic/create";
Topic.prototype.URL_EDIT = "/topic/edit";
Topic.prototype.URL_DEL = "/topic/del/{id}";
Topic.prototype.URL_STATUS = "/topic/status";

Topic.prototype.Status = Status;
Topic.prototype.StatusMap = StatusMap;
Topic.prototype.StatusList = Topic.prototype.getStatusList();
Topic.prototype.Type = Type;
Topic.prototype.TypeMap = TypeMap;
Topic.prototype.TypeList = Topic.prototype.getTypeList();


Topic.prototype.getFilters = function () {
	return [
		new Filter("SORT", "ID", "orderId"),
		new Filter("INPUT", "关键字", "keyword"),
		new Filter("INPUT", "名称", "name"),
		new Filter("SELECTION", "状态", "status", Topic.prototype.StatusList)
	];
}


//We use this method to get the full js Object.
Topic.prototype.render = function (obj) {

	BaseEntity.prototype.render.call(this, obj);

	//这里我们并不关心文章是什么，只关心id.
	if (obj && obj.articleId) {
		this.article.id = obj.articleId;
	}
	if (obj && obj.sceneryId) {
		this.scenery = new Scenery();
		this.scenery.render(sceneryMap[obj.sceneryId]);
	}
	if (obj && obj.themeId) {
		this.theme = new Theme();
		this.theme.render(themeMap[obj.themeId]);
	}


	this.renderEntity("poster", Tank);

	this.renderList("menus", TopicMenu);


	//将所有等级结点装配好
	for (let i = 0; i < this.menus.length; i++) {
		let menu = this.menus[i];
		menu.fillParentInfo(this, null);
	}
}

Topic.prototype.getForm = function () {

	let info = [];
	for (let i = 0; i < this.menus.length; i++) {
		let menu = this.menus[i];
		info.push(menu.getForm());
	}

	let form = {
		name: this.name,
		description: this.description,
		posterCode: this.poster.code,
		type: this.type,
		sceneryId: this.scenery.id,
		themeId: this.theme.id,
		articleId: this.article.id,
		location: this.location,
		menusInfo: JSON.stringify(info),
		remark: this.remark
	};
	if (this.id) {
		form.id = this.id;
	}

	return form;

}


//重置所有errrorMessage
Topic.prototype.resetMenuErrorMessage = function (menu) {
	menu.errorMessage = null;
	if (menu.menus && menu.menus.length !== 0) {

		for (let i = 0; i < menu.menus.length; i++) {
			let menu1 = menu.menus[i];

			this.resetMenuErrorMessage(menu1);
		}
	}
}

//递归验证每个menu的合理性。此处是验证menu相互之间的关系。TopicMenu内部是验证各个字段的。
Topic.prototype.validateMenu = function (menu) {


	if (menu.editMode) {
		this.errorMessage = "请确保所有菜单处于非编辑状态。";
		menu.errorMessage = "提交前请先关闭编辑状态！";

		return false;
	}


	if (menu.type === TopicMenu.prototype.Type.PARENT) {

		if (!menu.menus || menu.menus.length === 0) {
			this.errorMessage = "对于父级菜单请指定其子菜单";
			menu.errorMessage = "该菜单为父级菜单，提交前必须指定其子菜单";
			return false;
		} else {
			for (let i = 0; i < menu.menus.length; i++) {
				let attr = menu.menus[i];

				let b = this.validateMenu(attr);
				if (!b) {
					return b;
				}
			}
		}

	}

	menu.errorMessage = null;
	return true;
}


Topic.prototype.validate = function () {

	if (!this.name) {
		this.errorMessage = "标题必填！";
		return false;
	}

	if (!this.theme.id) {
		this.errorMessage = "请选择专题主题样式！";
		return false;
	}

	if (!this.location) {
		this.errorMessage = "访问地址必填！";
		return false;
	}

	if (this.location === "article" || this.location === "person" || this.location === "user" || this.location === "by" || this.location === "x1y2z3") {
		this.errorMessage = "article,person,user,x1y2z3为保留字，请勿在专题中作为访问地址使用！";
		return false;
	}


	if (this.type === Type.ARTICLE) {

		if (!this.article.id) {
			this.errorMessage = "请选择首页文章！";
			return false;
		}
	} else if (this.type === Type.SCENERY) {
		if (!this.scenery.id) {
			this.errorMessage = "请选择首页的定制页面！";
			return false;
		}
	} else {
		this.errorMessage = "请选择首页样式！";
		return false;
	}


	if (!this.menus || this.menus.length === 0) {
		this.errorMessage = "请选择菜单结构！";
		return false;
	}

	//reset all the errorMessages.
	for (let i = 0; i < this.menus.length; i++) {
		let menu = this.menus[i];

		this.resetMenuErrorMessage(menu);
	}

	for (let i = 0; i < this.menus.length; i++) {
		let menu = this.menus[i];

		let b = this.validateMenu(menu);
		if (!b) {
			return b;
		}
	}

	this.errorMessage = null;
	return true;
}

Topic.prototype.httpStatus = function (status, successCallback, failureCallback) {


	this.httpPost(this.URL_STATUS, {"id": this.id, status}, successCallback, failureCallback);

	return true;
}

//添加一个最外层的属性
Topic.prototype.addMenu = function () {

	let menu = new TopicMenu();
	menu.editMode = true;
	menu.level = 0;
	//指定好等级关系。
	menu.parentTopic = this;
	this.menus.push(menu);


}

//跳转到当前专题首页。
Topic.prototype.click = function () {

	Vue.router.push('/' + this.location);


}


//更新当前topic下面的菜单活动状态
Topic.prototype.refreshActiveMenus = function () {

	this.activeModuleMenu = null;
	this.activeChildMenu = null;
	if (!this.menus) {
		this.menus = [];
	}
	for (let i = 0; i < this.menus.length; i++) {

		let menu = this.menus[i];

		let active = startWith(location.pathname, menu.getUrl());

		if (active) {
			this.activeModuleMenu = menu;
		}

		if (!menu.menus) {
			menu.menus = [];
		}
		for (let i = 0; i < menu.menus.length; i++) {
			let subMenu = menu.menus[i];

			if (startWith(location.pathname, subMenu.getUrl())) {
				this.activeChildMenu = subMenu;
			}
		}
	}

}




// WEBPACK FOOTER //
// ./src/common/model/topic/Topic.js